module.exports = __webpack_public_path__ + "static/media/gr.dcc2c865.svg";